// Watchlist tier metadata. Mirrors backend TIER_LIMITS in
// app/api/watchlists.py. The DB stores live/tracked/idle directly
// (renamed from hot/warm/cold in migration 0010).

export type Tier = "live" | "tracked" | "idle";

export interface TierMeta {
  key: Tier;
  label: string;
  /** Bars active in the cadence dial (3 = fastest). */
  bars: 1 | 2 | 3;
  /** Plain-language refresh cadence — surfaced in tooltips. */
  cadence: string;
  /** Whether this tier participates in the daily analysis pass. */
  llm: boolean;
  /** Per-watchlist cap; mirrors backend TIER_LIMITS. */
  defaultLimit: number;
  /** One-line description for tooltips / picker descriptions. */
  desc: string;
}

export const TIERS: readonly Tier[] = ["live", "tracked", "idle"] as const;

export const TIER_META: Record<Tier, TierMeta> = {
  live: {
    key: "live",
    label: "Live",
    bars: 3,
    cadence: "news ~15 min",
    llm: true,
    defaultLimit: 5,
    desc: "Fastest news refresh + daily analysis. Reserve for active positions.",
  },
  tracked: {
    key: "tracked",
    label: "Tracked",
    bars: 2,
    cadence: "news hourly",
    llm: true,
    defaultLimit: 30,
    desc: "Hourly news + daily analysis. The default bucket.",
  },
  idle: {
    key: "idle",
    label: "Idle",
    bars: 1,
    cadence: "news every 6 h",
    llm: false,
    defaultLimit: 100,
    desc: "Background watch — slow news, no automated analysis.",
  },
};

export function tierLabel(tier: string): string {
  return TIER_META[(tier as Tier)]?.label ?? tier;
}
